'use client';

import { c as _c } from "react/compiler-runtime";
import { useI18n, useFormatNumber } from '@udemy-v2/i18n';
import classNames from 'classnames';
import styles from './enrollment-count.module.scss';
interface EnrollmentCountProps {
  /** The number of students enrolled in the course */
  count: number;
}

/**
 * Displays the number of students enrolled in a course
 * Uses i18n for number formatting and translation
 */
export const EnrollmentCount = t0 => {
  const $ = _c(8);
  const {
    count
  } = t0;
  const {
    gettext,
    interpolate
  } = useI18n();
  const {
    formatNumber
  } = useFormatNumber();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classNames(styles["student-count"], "ud-text-sm");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== count || $[2] !== formatNumber || $[3] !== gettext || $[4] !== interpolate) {
    t2 = interpolate(gettext("%(formattedCount)s students"), {
      formattedCount: formatNumber(count)
    }, true);
    $[1] = count;
    $[2] = formatNumber;
    $[3] = gettext;
    $[4] = interpolate;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <div className={t1}><span>{t2}</span></div>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};